import { useInvestorPortalAccess } from "contexts/InvestorPortalAccess";
import { useEffect } from "react";

export type IProps = {
	children: React.ReactNode;
	/**
	 * Appelé quand l'utilisateur ne peut pas consulter les invitations
	 */
	onNoAccess?: () => Promise<void> | void | undefined;
};

/**
 * Réserve la consultation des invitations aux conseillers et au Middle Office.
 */
export default function HasInvestorPortalAccess({ children, onNoAccess }: IProps) {
	const { canView } = useInvestorPortalAccess();

	useEffect(() => {
		if (!canView) void onNoAccess?.();
	}, [canView, onNoAccess]);

	if (!canView) return null;
	return <>{children}</>;
}
